import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { uniqBy, voucherImage } from '../../../core/helpers';

import { OrderService, ToastService } from '../../../core/services';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'gs-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.scss'],
    standalone: false
})
export class OrderListComponent implements OnInit, OnDestroy {
  @Input() orders: any[] = [];
  @Input() itemsPerPage: number = 5;
  @Input() canDisplayNoResultPage: boolean = true;
  @Input() canDisplayPagination: boolean = true;

  page: number = 1;

  private subscriptions: Subscription[] = [];

  constructor(
    private orderService: OrderService,
    private toastService: ToastService,
    private viewportScroller: ViewportScroller
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onPageChanged() {
    this.scroll();
  }

  getOrderStatusText(order: any): string {
    switch (order.status) {
      case 'Pending': {
        return 'In asteptare';
      }
      case 'Processing': {
        return 'In procesare';
      }
      case 'Completed': {
        return 'Finalizata';
      }
      case 'Failed': {
        return 'Esuata';
      }
    }

    return '';
  }

  hasGiftCardFiles(order: any): boolean {
    return order && order.orderItems && order.orderItems.some(x => !!x.giftCardFiles?.length);
  }

  getGiftCardFiles(order: any): any[] {
    return order.orderItems.reduce((giftCardFiles, x) => giftCardFiles.concat(x.giftCardFiles), []);
  }

  getVoucherImage(orderItem: any): string {
    return voucherImage(orderItem.voucherImage);
  }

  getVoucherImages(orderItems: any[]): string[] {
    return orderItems && uniqBy(orderItems, 'voucherId').map(x => voucherImage(x.voucherImage));
  }

  downloadGiftCard(giftCard: any) {
    this.subscriptions.push(
      this.orderService.downloadFile(`${environment.contentUrl}/giftcards/${giftCard.url}`, giftCard.url)
        .pipe(
          catchError(e => {
            this.toastService.show('Eroare', e.error?.detail || e.error?.title || 'A aparut o problema neasteptata. Echipa noastra lucreaza pentru a o remedia.', 'error');
            return throwError(e);
          })
        )
        .subscribe(() => { })
    );
  }

  private scroll() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
